export default "__VITE_ASSET___8JFspDg__"